import React from 'react';
import { WrapperWelcome } from './styles';
import backgroundImage from 'assets/images/loginBackground.png';
import nttdataPowered from 'assets/logos/nttdata-powered.svg';
import scctLogo from 'assets/logos/scct-small.svg';

export const WelcomeMessage = () => {
  return (
    <WrapperWelcome>
      <img
        className="background"
        src={backgroundImage}
        alt="Login background"
      />
      <div>
        <img src={scctLogo} alt="Control tower logo" />
        <h4>Customer Driven Supply Chain</h4>
        <h3>Control Tower</h3>
      </div>
      <img
        className="seat-code-logo"
        src={nttdataPowered}
        alt="powered by nttdata"
      />
    </WrapperWelcome>
  );
};
